// useSelectors.ts
import { useSelector } from "react-redux";
var useSelectors = function () {
    var _a = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
        loadingOneQuote: state.Quote.loadingOneQuote,
    }); }), responseOneQuote = _a.responseOneQuote, errorOneQuote = _a.errorOneQuote, loadingOneQuote = _a.loadingOneQuote;
    var _b = useSelector(function (state) { return ({
        loadingUpdateQuote: state.UpdateQuote.loadingUpdateQuote,
        errorUpdateQuote: state.UpdateQuote.errorUpdateQuote,
    }); }), loadingUpdateQuote = _b.loadingUpdateQuote, errorUpdateQuote = _b.errorUpdateQuote;
    var _c = useSelector(function (state) { return ({
        responsePatchQuote: state.UpdateQuote.responsePatchQuote,
        errorPatchQuote: state.UpdateQuote.errorPatchQuote,
        loadingPatchQuote: state.UpdateQuote.loadingPatchQuote,
    }); }), responsePatchQuote = _c.responsePatchQuote, errorPatchQuote = _c.errorPatchQuote, loadingPatchQuote = _c.loadingPatchQuote;
    var _d = useSelector(function (state) { return ({
        responseIdentificationType: state.IdentificationType.responseIdentificationType,
        errorIdentificationType: state.IdentificationType.errorIdentificationType,
    }); }), responseIdentificationType = _d.responseIdentificationType, errorIdentificationType = _d.errorIdentificationType;
    var _e = useSelector(function (state) { return ({
        responseCatalogGender: state.Plan.responseCatalogGender,
        errorCatalogGender: state.Plan.errorCatalogGender,
    }); }), responseCatalogGender = _e.responseCatalogGender, errorCatalogGender = _e.errorCatalogGender;
    var _f = useSelector(function (state) { return ({
        responseCountries: state.Countries.responseCountries,
        errorCountries: state.Countries.errorCountries,
    }); }), responseCountries = _f.responseCountries, errorCountries = _f.errorCountries;
    var _g = useSelector(function (state) { return ({
        responseRegion: state.Region.responseRegion,
        errorRegion: state.Region.errorRegion,
    }); }), responseRegion = _g.responseRegion, errorRegion = _g.errorRegion;
    var _h = useSelector(function (state) {
        var _a;
        return ({
            responsePlans: (_a = state.Plans.responsePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlans: state.Plans.errorPlans,
            loadingPlans: state.Plans.loadingPlans,
        });
    }), responsePlans = _h.responsePlans, errorPlans = _h.errorPlans, loadingPlans = _h.loadingPlans;
    var _j = useSelector(function (state) { return ({
        responseInsured: state.Insured.responseInsured,
        errorInsured: state.Insured.errorInsured,
        loadingInsured: state.Insured.loadingInsured,
    }); }), responseInsured = _j.responseInsured, errorInsured = _j.errorInsured, loadingInsured = _j.loadingInsured;
    var _k = useSelector(function (state) { return ({
        responseDeleteInsured: state.Insured.responseDeleteInsured,
        errorDeleteInsured: state.Insured.errorDeleteInsured,
        loadingDeleteInsured: state.Insured.loadingDeleteInsured,
    }); }), responseDeleteInsured = _k.responseDeleteInsured, errorDeleteInsured = _k.errorDeleteInsured, loadingDeleteInsured = _k.loadingDeleteInsured;
    var _l = useSelector(function (state) { return ({
        responsePlan: state.Plan.responsePlan,
        errorPlan: state.Plan.errorPlan,
        loading: state.Plan.loadingPlan,
    }); }), responsePlan = _l.responsePlan, errorPlan = _l.errorPlan, loading = _l.loading;
    var _m = useSelector(function (state) { return ({
        responseUpdatePerson: state.Person.responseUpdatePerson,
        errorUpdatePerson: state.Person.errorUpdatePerson,
        loadingUpdatePerson: state.Person.loadingUpdatePerson,
    }); }), responseUpdatePerson = _m.responseUpdatePerson, errorUpdatePerson = _m.errorUpdatePerson, loadingUpdatePerson = _m.loadingUpdatePerson;
    var _o = useSelector(function (state) { return ({
        responseBenefit: state.Beneficiary.responseBenefit,
        errorBenefit: state.Beneficiary.errorBenefit,
        loadingBenefit: state.Beneficiary.loadingBenefit,
    }); }), responseBenefit = _o.responseBenefit, errorBenefit = _o.errorBenefit, loadingBenefit = _o.loadingBenefit;
    var _p = useSelector(function (state) { return ({
        responseBeneficiary: state.Beneficiary.responseBeneficiary,
        errorBeneficiary: state.Beneficiary.errorBeneficiary,
        loadingBeneficiary: state.Beneficiary.loadingBeneficiary,
    }); }), responseBeneficiary = _p.responseBeneficiary, errorBeneficiary = _p.errorBeneficiary, loadingBeneficiary = _p.loadingBeneficiary;
    var _q = useSelector(function (state) { return ({
        responsePatchBeneficiary: state.Beneficiary.responsePatchBeneficiary,
        errorPatchBeneficiary: state.Beneficiary.errorPatchBeneficiary,
        loadingPatchBeneficiary: state.Beneficiary.loadingPatchBeneficiary,
    }); }), responsePatchBeneficiary = _q.responsePatchBeneficiary, errorPatchBeneficiary = _q.errorPatchBeneficiary, loadingPatchBeneficiary = _q.loadingPatchBeneficiary;
    var _r = useSelector(function (state) { return ({
        responsePostInsured: state.Insured.responsePostInsured,
        errorPostInsured: state.Insured.errorPostInsured,
        loadingPostInsured: state.Insured.loadingPostInsured,
    }); }), responsePostInsured = _r.responsePostInsured, errorPostInsured = _r.errorPostInsured, loadingPostInsured = _r.loadingPostInsured;
    var _s = useSelector(function (state) { return ({
        responsePatchInsured: state.Insured.responsePatchInsured,
        errorPatchInsured: state.Insured.errorPatchInsured,
        loadingPatchInsured: state.Insured.loadingPatchInsured,
    }); }), responsePatchInsured = _s.responsePatchInsured, errorPatchInsured = _s.errorPatchInsured, loadingPatchInsured = _s.loadingPatchInsured;
    var _t = useSelector(function (state) {
        var _a;
        return ({
            responsePageActionFlags: (_a = state.PageActionFlags.responsePageActionFlags) === null || _a === void 0 ? void 0 : _a.data,
            errorPageActionFlags: state.PageActionFlags.errorPageActionFlags,
            loadingPageActionFlags: state.PageActionFlags.loadingPageActionFlags,
        });
    }), responsePageActionFlags = _t.responsePageActionFlags, errorPageActionFlags = _t.errorPageActionFlags, loadingPageActionFlags = _t.loadingPageActionFlags;
    var _u = useSelector(function (state) {
        var _a;
        return ({
            responseOneProject: (_a = state.Project.responseOneProject) === null || _a === void 0 ? void 0 : _a.data,
            errorOneProject: state.Project.errorOneProject,
            loadingOneProject: state.Project.loadingOneProject,
        });
    }), responseOneProject = _u.responseOneProject, errorOneProject = _u.errorOneProject, loadingOneProject = _u.loadingOneProject;
    var _v = useSelector(function (state) { return ({
        responsePolicyConfirm: state.Policy.responsePolicyConfirm,
        responsePolicyConfirmError: state.Policy.errorPolicyConfirm,
        responsePolicyConfirmLoading: state.Policy.loadingPolicyConfirm,
    }); }), responsePolicyConfirm = _v.responsePolicyConfirm, responsePolicyConfirmError = _v.responsePolicyConfirmError, responsePolicyConfirmLoading = _v.responsePolicyConfirmLoading;
    return {
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
        loadingUpdateQuote: loadingUpdateQuote,
        errorUpdateQuote: errorUpdateQuote,
        responsePatchQuote: responsePatchQuote,
        errorPatchQuote: errorPatchQuote,
        loadingPatchQuote: loadingPatchQuote,
        responseIdentificationType: responseIdentificationType,
        errorIdentificationType: errorIdentificationType,
        responseCatalogGender: responseCatalogGender,
        errorCatalogGender: errorCatalogGender,
        responsePlan: responsePlan,
        errorPlan: errorPlan,
        loading: loading,
        responseCountries: responseCountries,
        errorCountries: errorCountries,
        responseRegion: responseRegion,
        errorRegion: errorRegion,
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
        responseInsured: responseInsured,
        errorInsured: errorInsured,
        responseDeleteInsured: responseDeleteInsured,
        errorDeleteInsured: errorDeleteInsured,
        loadingDeleteInsured: loadingDeleteInsured,
        responsePostInsured: responsePostInsured,
        errorPostInsured: errorPostInsured,
        loadingPostInsured: loadingPostInsured,
        responsePatchInsured: responsePatchInsured,
        errorPatchInsured: errorPatchInsured,
        loadingPatchInsured: loadingPatchInsured,
        responseUpdatePerson: responseUpdatePerson,
        errorUpdatePerson: errorUpdatePerson,
        loadingUpdatePerson: loadingUpdatePerson,
        responseBenefit: responseBenefit,
        errorBenefit: errorBenefit,
        loadingBenefit: loadingBenefit,
        responsePatchBeneficiary: responsePatchBeneficiary,
        errorPatchBeneficiary: errorPatchBeneficiary,
        loadingPatchBeneficiary: loadingPatchBeneficiary,
        responseBeneficiary: responseBeneficiary,
        errorBeneficiary: errorBeneficiary,
        loadingBeneficiary: loadingBeneficiary,
        responsePageActionFlags: responsePageActionFlags,
        errorPageActionFlags: errorPageActionFlags,
        loadingPageActionFlags: loadingPageActionFlags,
        responseOneProject: responseOneProject,
        errorOneProject: errorOneProject,
        loadingOneProject: loadingOneProject,
        loadingInsured: loadingInsured,
        responsePolicyConfirm: responsePolicyConfirm,
        responsePolicyConfirmError: responsePolicyConfirmError,
        responsePolicyConfirmLoading: responsePolicyConfirmLoading,
    };
};
export default useSelectors;
